// eslint-disable-next-line import/prefer-default-export
export const msgs = {
  pamManageItemsModal: {
    modalHeader: {
      id: 'pam.pamManageItemsModal.modalHeader',
      defaultMessage: 'Manage Selections',
    },
    modalSubTitle: {
      id: 'pam.pamManageItemsModal.modalSubTitle',
      defaultMessage:
        'View or remove the roles associated with this privileged access request',
    },
    modalSubTitleInlineMsg: {
      id: 'pam.pamManageItemsModal.modalSubTitleInlineMsg',
      defaultMessage:
        'Review or remove your role selections here. Go back to the selection page to add more roles.',
    },
    modalSelectionPage: {
      id: 'pam.pamManageItemsModal.modalSelectionPage',
      defaultMessage: 'Selection Page',
    },
    modalFooterMsg: {
      id: 'pam.pamManageItemsModal.modalFooterMsg',
      defaultMessage: 'Check at least one item to proceed.',
    },
    modalSave: {
      id: 'pam.common.save',
      defaultMessage: 'Save',
    },
    modalCancel: {
      id: 'pam.common.cancel',
      defaultMessage: 'Cancel',
    },
  },
};
